import { type ReactNode } from "react";

import HiraLogo from "@/components/icons/HiraLogo";

export default function GuestRequestLayout({
  children,
  footer,
  variant = "form",
}: {
  children: ReactNode;
  footer?: ReactNode;
  variant?: "form" | "status";
}) {
  return (
    <div
      className={
        variant === "form"
          ? "flex min-h-dvh flex-col bg-gray-50"
          : "flex min-h-dvh flex-col bg-white"
      }
    >
      <header className="sticky top-0 z-20 border-b border-gray-200 bg-white">
        <div className="mx-auto flex w-full max-w-[1920px] items-center py-6 ps-8">
          <HiraLogo />
        </div>
      </header>
      <main className="mx-auto flex min-h-0 w-full max-w-[1920px] flex-1 flex-col p-8">
        {variant === "form" ? (
          <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto rounded-[20px] border border-gray-200 bg-white p-8">
            {children}
          </div>
        ) : (
          children
        )}
      </main>
      {footer ? (
        <footer className="sticky bottom-0 border-t border-gray-200 bg-white">
          <div className="mx-auto flex w-full max-w-[1920px] items-center justify-center gap-3 px-8 pt-6 pb-8">
            {footer}
          </div>
        </footer>
      ) : null}
    </div>
  );
}
